/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

// Importación de módulos y componentes necesarios
import { useState, useEffect, useCallback } from 'react';
import { format } from 'date-fns';
import {
  TextField,
  InputAdornment,
  Modal,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Switch,
  Paper,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Box
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { Search as SearchIcon, Add as AddIcon } from '@mui/icons-material';
import Swal from 'sweetalert2';
import useStyles from './styles';
import editarImage from '../../../../images/editar.png';
import eliminarImage from '../../../../images/eliminar.png';
import { clientAxios8080 } from '../../../../configs/axios';
import LoadingOverlay from "../../../loading-overlay";

function UmbralDetalle() {
  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const [umbrales, setUmbrales] = useState([]); // Inicializar con un array vacío
  const [metricas, setMetricas] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalUmbralId, setModalUmbralId] = useState(null);
  const [modalMetricaId, setModalMetricaId] = useState(null);
  const [modalColor, setModalColor] = useState('');
  const [modalUmbralMin, setModalUmbralMin] = useState('');
  const [modalUmbralMax, setModalUmbralMax] = useState('');
  const [modalMasEsMejor, setModalMasEsMejor] = useState(true);
  const [modalInicioVigencia, setModalInicioVigencia] = useState('');
  const [modalFinVigencia, setModalFinVigencia] = useState('');
  const [modalPonderacion, setModalPonderacion] = useState(null);
  const [searchValue, setSearchValue] = useState('');
  const [colorError, setColorError] = useState('');
  const [umbralMinError, setUmbralMinError] = useState('');
  const [umbralMaxError, setUmbralMaxError] = useState('');
  const [masEsMejorError, setMasEsMejorError] = useState('');
  const [inicioVigenciaError, setInicioVigenciaError] = useState('');
  const [finVigenciaError, setFinVigenciaError] = useState('');
  const [ponderacionError, setPonderacionError] = useState('');
  const [metricaIdError, setMetricaIdError] = useState('');
  const [modalFechaCreacion, setModalFechaCreacion] = useState('');
  const [modalStatus, setModalStatus] = useState(true);
  const [filteredUmbrales, setFilteredUmbrales] = useState([]);
  const [modalMetricaIdSelect, setModalMetricaIdSelect] = useState('');
  const [selectedMetrica, setSelectedMetrica] = useState('');
  const formattedDate = new Date().toISOString();
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);

  const modalStyle = {
    position: 'absolute',
    width: '50%',
    bgcolor: 'background.paper',
    p: 4,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    zIndex: 100,
  };

  async function getMetrica() {
    try {
      const response = await clientAxios8080.get('/ms-catalogos/filtros/niveles/servicio/metricas');
      const responseData = response.data.data;
      setMetricas(responseData);
    } catch (error) {
    }
  }

  async function getUmbral() {
    try {
      const response = await clientAxios8080.get('/ms-catalogos/filtros/umbral');
      const responseData = response.data;
      responseData.sort((a, b) => a.id - b.id);
      setUmbrales(responseData); 
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const postUmbral = async () => {
    try {
      const newUmbralData = {
        id: modalUmbralId,
        umbralMin: modalUmbralMin,
        umbralMax: modalUmbralMax,
        color: modalColor,
        metricaLectura: {
          id: modalMetricaIdSelect,
        },
        masEsMejor: modalMasEsMejor,
        inicioVigencia: modalInicioVigencia,
        finVigencia: modalFinVigencia,
        fechaCreacion: formattedDate,
        status: modalStatus,
        ponderacion: modalPonderacion,
      };

      const response = await clientAxios8080.post('/ms-catalogos/filtros/umbral', newUmbralData);
      console.log('Datos que se enviarán en la solicitud POST:', newUmbralData); // Agrega esto a postUmbral

      if (response.status === 200) {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Registro agregado con éxito',
          showConfirmButton: false,
          timer: 4200,
        });
        getUmbral();
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Error al procesar la solicitud',
          text: response.data.error || 'Hubo un error al procesar la solicitud.',
        });
        setLoading(false)
      }
    } catch (error) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Error al procesar la solicitud',
        text: error || 'Hubo un error al procesar la solicitud.',
      });
      setLoading(false)
    }
  };

  const putUmbral = async () => {
    try {
      const updatedUmbralData = {
        id: modalUmbralId,
        umbralMin: modalUmbralMin,
        umbralMax: modalUmbralMax,
        color: modalColor,
        metricaLectura: {
          id: modalMetricaIdSelect,
        },
        masEsMejor: modalMasEsMejor,
        inicioVigencia: modalInicioVigencia,
        finVigencia: modalFinVigencia,
        fechaCreacion: formattedDate,
        status: modalStatus,
        ponderacion: modalPonderacion,
      };

      const response = await clientAxios8080.put(`/ms-catalogos/filtros/umbral/`, updatedUmbralData);
      if (response.status === 200) {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Registro editado con éxito',
          showConfirmButton: false,
          timer: 4200,
        });
        getUmbral();
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Error al procesar la solicitud',
          text: response.data.error || 'Hubo un error al procesar la solicitud.',
        });
        setLoading(false)
      }
    } catch (error) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Error al procesar la solicitud',
        text: error || 'Hubo un error al procesar la solicitud.',
      });
      setLoading(false)
    }
  };

  const deleteUmbral = async (id) => {
    try {
      const response = await clientAxios8080.delete(`/ms-catalogos/filtros/umbral?id=${id}`);

      if (response.status === 200) {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Registro eliminado con éxito.',
          showConfirmButton: false,
          timer: 2400,
        });
        getUmbral(); // Update the list after deletion
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Error al procesar la solicitud',
          text: response.data.error || 'Hubo un error al procesar la solicitud.',
        });
        setLoading(false)
      }
    } catch (error) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Error al procesar la solicitud',
        text: error || 'Hubo un error al procesar la solicitud.',
      });
      setLoading(false)
    }
  };

  useEffect(() => {
    getUmbral();
    getMetrica();
  }, []);

  // Maneja el clic en el botón "Agregar Nuevo"
  const handleAgregarClick = () => {
    setIsModalOpen(true);
    setModalUmbralId(null);
    setModalUmbralMin(null);
    setModalUmbralMax(null);
    setModalColor('');
    setModalMetricaId(null);
    setModalMasEsMejor(true);
    setModalInicioVigencia('');
    setModalFinVigencia('');
    setModalFechaCreacion(formattedDate);
    setModalStatus(true);
    setModalPonderacion(null);
  };

  // Maneja el clic en el botón "Editar"
  const handleEditarClick = (
    id,
    umbralMin,
    umbralMax,
    color,
    metricaId,
    masEsMejor,
    inicioVigencia,
    finVigencias,
    fechaCreacion,
    status,
    ponderacion
  ) => {
    setIsModalOpen(true);
    setModalUmbralId(id);
    setModalUmbralMin(umbralMin);
    setModalUmbralMax(umbralMax);
    setModalFinVigencia(finVigencias);
    setModalInicioVigencia(inicioVigencia);
    setModalColor(color);

    // Busca el objeto correspondiente en metricas
    const selectedMetricaObject = metricas.find((metrica) => metrica.id === metricaId);

    if (selectedMetricaObject) {
      setModalMetricaIdSelect(selectedMetricaObject.id); // Set the selected metrica ID
      setSelectedMetrica(selectedMetricaObject.id); // Actualiza el estado selectedMetrica
    }
    setModalMasEsMejor(masEsMejor);
    setSelectedStartDate(new Date(inicioVigencia));
    setSelectedEndDate(new Date(finVigencias));
    setModalFechaCreacion(fechaCreacion);
    setModalStatus(status);
    setModalPonderacion(ponderacion);
  };

  // Maneja el cambio en el campo "Color"
  const handleColorChange = (e) => {
    console.log('handleColorChange function called');
    const newColor = e.target.value;
    setModalColor(newColor);

    if (newColor.trim().length === 0) {
      setColorError('El color no puede estar vacío.');
    } else if (newColor.trim().length < 3) {
      setColorError('El color debe tener al menos 3 caracteres.');
    } else {
      const textRegex = /^[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ\s]*$/;

      if (textRegex.test(newColor)) {
        setColorError('');
      } else {
        setColorError('El texto contiene caracteres no permitidos.')
      }
    }
  };

  // Maneja el cambio en el campo "Umbral Min"
  const handleUmbralMinChange = (e) => {
    const newUmbralMin = e.target.value;
    setModalUmbralMin(newUmbralMin);

    if (!newUmbralMin) {
      setUmbralMinError('El umbral mínimo no puede estar vacío.');
    } else {
      setUmbralMinError('');
    }
  };

  // Maneja el cambio en el campo "Umbral Max"
  const handleUmbralMaxChange = (e) => {
    const newUmbralMax = e.target.value;
    setModalUmbralMax(newUmbralMax);

    if (!newUmbralMax) {
      setUmbralMaxError('El umbral máximo no puede estar vacío.');
    } else {
      setUmbralMaxError('');
    }
  };

  // Maneja el cambio en el campo "Mas Es Mejor"
  const handleMasEsMejorChange = (e) => {
    const newMasEsMejor = e.target.checked;
    setModalMasEsMejor(newMasEsMejor);
  };

  // Maneja el cambio en el campo "Inicio Vigencia"
  const handleInicioVigenciaChange = (date) => {
    setModalInicioVigencia(date.toISOString());

    // Validar que la fecha de inicio no sea después de la fecha de fin
    if (selectedEndDate && date > selectedEndDate) {
      setInicioVigenciaError('La fecha de inicio no puede ser después de la fecha de fin.');
    } else {
      setInicioVigenciaError('');
    }
  };

  // Maneja el cambio en el campo "Fin Vigencia"
  const handleFinVigenciaChange = (date) => {
    setModalFinVigencia(date.toISOString());

    // Validar que la fecha de fin no sea antes de la fecha de inicio
    if (selectedStartDate && date < selectedStartDate) {
      setFinVigenciaError('La fecha de fin no puede ser antes de la fecha de inicio.');
    } else {
      setFinVigenciaError('');
    }
  };

  // Maneja el cambio en el estado de "Estatus"
  const handleStatusChange = async (umbralId) => {
    try {
      const updatedUmbral = umbrales.find((umbral) => umbral.id === umbralId);

      if (!updatedUmbral) {
        console.error('No se encontró el umbral para actualizar el estado.');
        return;
      }

      const newStatus = !updatedUmbral.status;

      const updatedUmbralData = {
        id: updatedUmbral.id,
        umbralMin: updatedUmbral.umbralMin,
        umbralMax: updatedUmbral.umbralMax,
        color: updatedUmbral.color,
        metricaLectura: {
          id: updatedUmbral.metricaLectura.id,
        },
        masEsMejor: updatedUmbral.masEsMejor,
        inicioVigencia: updatedUmbral.inicioVigencia,
        finVigencia: updatedUmbral.finVigencia,
        fechaCreacion: updatedUmbral.fechaCreacion,
        status: newStatus, // Establece el nuevo estado aquí
        ponderacion: updatedUmbral.ponderacion,
      };

      const url = `/ms-catalogos/filtros/umbral/`;

      const response = await clientAxios8080.put(url, updatedUmbralData);

      if (response.status === 200) {
       //Actualizar el estado local para reflejar el nuevo estado
        const updatedUmbrales = umbrales.map((umbral) => (umbral.id === umbralId ? { ...umbral, status: newStatus } : umbral));
        setUmbrales(updatedUmbrales);
        const title = updatedUmbralData.status ? 'Umbral activado exitosamente.' : 'Umbral desactivado exitosamente.';
        Swal.fire({
          position: 'center',
          icon: 'success',
          title,
          showConfirmButton: false,
          timer: 1200,
        });
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Error al procesar la solicitud',
          text: response.data.error || 'Hubo un error al procesar la solicitud.',
        });
        setLoading(false)
      }
    } catch (error) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Error al procesar la solicitud',
        text: error || 'Hubo un error al procesar la solicitud.',
      });
      setLoading(false)
    }
  };

  // Maneja el clic en el botón "Guardar"
  const handleGuardarClick = async () => {
    setLoading(true)
    let newColorError = '';
    let newMetricaError = '';
    let newUmbralMinError = '';
    let newUmbralMaxError = '';
    let newInicioVigenciaError = '';
    let newFinVigenciaError = '';

    if (modalColor.trim().length === 0) {
      newColorError = 'El color no puede estar vacío.';
    } else if (modalColor.trim().length < 3) {
      newColorError = 'El color debe tener al menos 3 caracteres.';
    }

    // Validar la métrica
    if (!modalMetricaIdSelect) {
      newMetricaError = 'Debe seleccionar una métrica.';
    }

    // Validar el umbral mínimo
    if (!modalUmbralMin) {
      newUmbralMinError = 'El umbral mínimo no puede estar vacío.';
    }

    // Validar el umbral máximo
    if (!modalUmbralMax) {
      newUmbralMaxError = 'El umbral máximo no puede estar vacío.';
    }

    // Validar si umbral mínimo es mayor al umbral máximo
    if (modalUmbralMin && modalUmbralMax && parseFloat(modalUmbralMin) > parseFloat(modalUmbralMax)) {
      newUmbralMinError = 'El umbral mínimo debe ser menor o igual al umbral máximo.';
      newUmbralMaxError = 'El umbral máximo debe ser mayor o igual al umbral mínimo.';
    }

    // Validar las fechas
    if (!modalInicioVigencia) {
      newInicioVigenciaError = 'La fecha de inicio vigencia no puede estar vacía.';
    }

    if (!modalFinVigencia) {
      newFinVigenciaError = 'La fecha de fin vigencia no puede estar vacía.';
    }
    
    setColorError(newColorError);
    setMetricaIdError(newMetricaError);
    setUmbralMinError(newUmbralMinError);
    setUmbralMaxError(newUmbralMaxError);
    setFinVigenciaError(newFinVigenciaError);
    setInicioVigenciaError(newInicioVigenciaError);
    // Si no hay errores, guarda el umbral
    if (
      !newColorError &&
      !newMetricaError &&
      !newUmbralMinError &&
      !newUmbralMaxError &&
      !newInicioVigenciaError &&
      !newFinVigenciaError 
    ) {
      if (modalUmbralId !== null) {
          await putUmbral(); // Llama a la función para actualizar el umbral

          // Cerrar el modal y resetear los campos
          setIsModalOpen(false);
          setModalColor('');
          setModalMetricaIdSelect('');
          setSelectedMetrica(''); // Establece selectedMetrica a vacío
          if (modalColor.trim().length >= 3) {
            setColorError('');
          }
      } else {
        // Agregar nueva umbral (Este bloque solo debe ejecutarse cuando no estás editando)
          // Asigna el valor seleccionado de modalMetricaIdSelect a modalMetricaId
          setModalMetricaId(modalMetricaIdSelect);

          await postUmbral(); // Llama a la función para crear una nueva umbral
        
          // Cerrar el modal y resetear los campos
          setIsModalOpen(false);
          setModalUmbralMin(null);
          setModalUmbralMax(null);
          setModalColor('');
          setModalMasEsMejor(true);
          setModalInicioVigencia('');
          setModalFinVigencia('');
          setModalPonderacion(null);
          setModalMetricaIdSelect('');
          setSelectedMetrica(''); // Establece selectedMetrica a vacío
          if (modalColor.trim().length >= 3) {
            setColorError('');
          }
      }
    }
  };

  // Maneja el clic en el botón "Eliminar"
  const handleEliminarClick = (id) => {
    Swal.fire({
      title: '¿Está seguro?',
      text: 'Esta acción no se puede revertir.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          // Call the deleteRegion function to delete the entity
          await deleteUmbral(id);
          
        } catch (error) {
          console.error('Error al eliminar la región:', error);

          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Error al eliminar el registro.',
            showConfirmButton: false,
            timer: 1200,
          });
        }
      }
    });
  };

  const handleSearchChange = (e) => {
    const searchTerm = e.target.value;
    setSearchValue(searchTerm);

    // Filtra los datos según el término de búsqueda
    filterUmbrales(searchTerm);
  };

  const removeAccents = (str) => {
    return str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();
  };

  const filterUmbrales = useCallback(
    (searchTerm) => {
      if (!searchTerm) {
        // Manejar el caso en que searchTerm sea nulo o indefinido
        setFilteredUmbrales(umbrales);
        return;
      }

      // Normaliza el término de búsqueda y los datos antes de comparar (ignorando mayúsculas/minúsculas)
      const normalizedSearchTerm = removeAccents(searchTerm.toLowerCase());
      const filteredData = umbrales.filter((umbral) => {
        const normalizedColor = removeAccents((umbral.color || '').toLowerCase());
        const normalizedMetrica = removeAccents((umbral.metricaLectura.metrica || '').toLowerCase());

        // Comprueba si el término de búsqueda está en cualquiera de los campos
        return normalizedColor.includes(normalizedSearchTerm) || normalizedMetrica.includes(normalizedSearchTerm);
      });
      setFilteredUmbrales(filteredData);
    },
    [umbrales]
  );

  useEffect(() => {
    // Actualiza los resultados filtrados cuando cambia el estado de umbrales o searchValue
    filterUmbrales(searchValue);
  }, [umbrales, searchValue, filterUmbrales]);

  // Renderiza el componente
  return (
    <div className={classes.root}>
      <h1>Detalle del Catálogo para Umbrales</h1>
      <div className={classes.filterAndButton}>
        <TextField
          className={classes.searchField}
          label="Buscar"
          variant="outlined"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          value={searchValue}
          onChange={handleSearchChange} // Manejar cambios en el campo de búsqueda
        />
        <Button variant="contained" color="success" className={classes.addButton} onClick={handleAgregarClick} startIcon={<AddIcon />}>
          Agregar Nuevo
        </Button>
      </div>
      <TableContainer component={Paper} className={classes.tableContainer}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow className={classes.headerRow}>
              <TableCell align="center">Id</TableCell>
              <TableCell align="center">Metrica</TableCell>
              <TableCell align="center">Umbral Min</TableCell>
              <TableCell align="center">Umbral Max</TableCell>
              <TableCell align="center">Color</TableCell>
              <TableCell align="center">Fecha de Creación</TableCell>
              <TableCell align="center">Fecha de Inicio Vigencia</TableCell>
              <TableCell align="center">Fecha de Fin Vigencia</TableCell>
              <TableCell align="center">Ponderación</TableCell>
              <TableCell align="center">Bomasesmejor</TableCell>
              <TableCell align="center">Estatus</TableCell>
              <TableCell align="center">Editar</TableCell>
              <TableCell align="center">Eliminar</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredUmbrales.length === 0 ? (
              <TableRow>
                <TableCell colSpan={7} align="center">
                  No se encontraron resultados.
                </TableCell>
              </TableRow>
            ) : (
              filteredUmbrales.map((umbral) => (
                <TableRow key={umbral.id}>
                  <TableCell align="center">{umbral.id}</TableCell>
                  <TableCell align="center">{umbral.metricaLectura.metrica}</TableCell>
                  <TableCell align="center">{umbral.umbralMin}</TableCell>
                  <TableCell align="center">{umbral.umbralMax}</TableCell>
                  <TableCell align="center">{umbral.color}</TableCell>
                  <TableCell align="center">{format(new Date(umbral.fechaCreacion), 'yyyy-MM-dd')}</TableCell>
                  <TableCell align="center">{format(new Date(umbral.inicioVigencia), 'yyyy-MM-dd')}</TableCell>
                  <TableCell align="center">{format(new Date(umbral.finVigencia), 'yyyy-MM-dd')}</TableCell>
                  <TableCell align="center">{umbral.ponderacion || 'N/A'}</TableCell>
                  <TableCell align="center">{umbral.masEsMejor ? 'Sí' : 'No'}</TableCell>
                  <TableCell align="center">
                    <div className={classes.centeredSwitch}>
                      <Switch checked={umbral.status} onChange={() => handleStatusChange(umbral.id)} className={classes.customSwitch} />
                    </div>
                  </TableCell>
                  <TableCell align="center">
                    <div className={`${classes.imageButtonEditar} ${classes.imageButtonWithMargin}`}>
                      <img
                        src={editarImage}
                        alt="Editar"
                        className={`${classes.imageButtonEditar} ${classes.imageButtonWithMargin}`}
                        onClick={() =>
                          handleEditarClick(
                            umbral.id,
                            umbral.umbralMin,
                            umbral.umbralMax,
                            umbral.color,
                            umbral.metricaLectura.id,
                            umbral.masEsMejor,
                            umbral.inicioVigencia,
                            umbral.finVigencia,
                            umbral.fechaCreacion,
                            umbral.status,
                            umbral.ponderacion
                          )
                        }
                      />
                    </div>
                  </TableCell>
                  <TableCell align="center">
                    <div className={`${classes.imageButtonEliminar} ${classes.imageButtonWithMargin}`}>
                      <img
                        src={eliminarImage}
                        alt="Eliminar"
                        className={`${classes.imageButtonEliminar} ${classes.imageButtonWithMargin}`}
                        onClick={() => handleEliminarClick(umbral.id)}
                      />
                    </div>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {loading && <LoadingOverlay />}
      <Modal open={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <Box sx={modalStyle}>
          <h2>{modalUmbralId !== null ? 'Editar Elemento' : 'Agregar nuevo elemento'}</h2>
          <FormControl variant="outlined" className={classes.modalTextField} error={Boolean(metricaIdError)}>
            <InputLabel id="metricaLabel" htmlFor="metricaSelect" {...(metricaIdError ? { style: { color: 'red' } } : {})}>
              Métrica
            </InputLabel>
            <Select
              labelId="metricaLabel"
              id="metricaSelect"
              label="Métrica"
              value={modalMetricaIdSelect}
              onChange={(e) => setModalMetricaIdSelect(e.target.value)}
            >
              {metricas.map((metrica) => (
                <MenuItem key={metrica.id} value={metrica.id}>
                  {metrica.metrica}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText className={classes.errorText}>{metricaIdError}</FormHelperText>
          </FormControl>

          <TextField
            label="Umbral Min"
            variant="outlined"
            value={modalUmbralMin || ''} // Asegura que value no sea nulo
            onChange={handleUmbralMinChange}
            className={classes.modalTextField}
            error={umbralMinError !== ''}
            helperText={umbralMinError}
            type="number"
          />
          <TextField
            label="Umbral Max"
            variant="outlined"
            value={modalUmbralMax || ''} // Asegura que value no sea nulo
            onChange={handleUmbralMaxChange}
            className={classes.modalTextField}
            error={umbralMaxError !== ''}
            helperText={umbralMaxError}
            type="number"
          />
          <TextField
            label="Color"
            variant="outlined"
            value={modalColor}
            onChange={handleColorChange}
            className={classes.modalTextField}
            error={colorError !== ''}
            helperText={colorError}
          />
          <TextField
            label="Ponderación"
            variant="outlined"
            value={modalPonderacion || ''}
            onChange={(e) => {
              const inputPonderacion = e.target.value;

              if (/^\d+(\.\d{0,2})?$/.test(inputPonderacion) || inputPonderacion === '') {
                setModalPonderacion(inputPonderacion);
                setPonderacionError('');
              } else {
                setPonderacionError('La ponderación debe ser un número con hasta 2 decimales');
              }
            }}
            className={classes.modalTextField}
            error={ponderacionError !== ''}
            helperText={ponderacionError}
          />
          <FormControl variant="outlined" className={classes.modalTextField}>
            <InputLabel id="masEsMejor-select-label">¿Bomas es mejor?</InputLabel>
            <Select
              labelId="masEsMejor-select-label"
              id="masEsMejor-select"
              value={modalMasEsMejor ? 1 : 0}
              onChange={(e) => setModalMasEsMejor(e.target.value === 1)}
              label="Bomasesmejor"
            >
              <MenuItem value={1}>Sí</MenuItem>
              <MenuItem value={0}>No</MenuItem>
            </Select>
          </FormControl>

          <div className={classes.datePickerContainer}>
            <div className={classes.datePickerWrapper}>
              <DatePicker
                label="Inicio Vigencia"
                value={selectedStartDate}
                onChange={(date) => {
                  setSelectedStartDate(date);
                  handleInicioVigenciaChange(date);
                }}
                format="yyyy-MM-dd HH:mm:ss.SSS"
                renderInput={(params) => <TextField {...params} variant="outlined" />}
                className={classes.modalTextField}
              />
              <FormHelperText error className={classes.errorText}>
                {inicioVigenciaError}
              </FormHelperText>
            </div>

            <div className={classes.datePickerWrapper}>
              <DatePicker
                label="Fin Vigencia"
                value={selectedEndDate}
                onChange={(date) => {
                  setSelectedEndDate(date);
                  handleFinVigenciaChange(date);
                }}
                format="yyyy-MM-dd HH:mm:ss.SSS"
                renderInput={(params) => <TextField {...params} variant="outlined" />}
                className={classes.modalTextField}
              />
              <FormHelperText error className={classes.errorText}>
                {finVigenciaError}
              </FormHelperText>
            </div>
          </div>

          <div className={classes.modalButtons}>
            <Button variant="contained" color="primary" onClick={handleGuardarClick} className={classes.guardarButton}>
              Guardar
            </Button>
            <Button variant="outlined" color="secondary" onClick={() => setIsModalOpen(false)} className={classes.cancelarButton}>
              Cancelar
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export default UmbralDetalle;
